"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationActionType;
(function (NotificationActionType) {
    NotificationActionType[NotificationActionType["AsyncSendFailed"] = 0] = "AsyncSendFailed";
    NotificationActionType[NotificationActionType["AddFavoritePersonaFailedNotification"] = 1] = "AddFavoritePersonaFailedNotification";
    NotificationActionType[NotificationActionType["RemoveFavoritePersonaFailedNotification"] = 2] = "RemoveFavoritePersonaFailedNotification";
    NotificationActionType[NotificationActionType["PeopleHubNotification"] = 3] = "PeopleHubNotification";
    NotificationActionType[NotificationActionType["SkypeNotification"] = 4] = "SkypeNotification";
})(NotificationActionType = exports.NotificationActionType || (exports.NotificationActionType = {}));
//# sourceMappingURL=NotificationViewState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-header-toast-notification/lib/store/schema/NotificationViewState.js
// module id = 369
// module chunks = 3 14 105 106 107